import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { toast } from '@repo/toast';
import { TestId } from '@repo/test-id';
import { tr } from '@repo/locale';

import { ParkingProvider } from '@features/ownedParkingManage/contexts/ParkingContext';
import { useDashboardParkingData } from '@features/ownedParkingManage/hooks/useDashboardParkingData';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function ParkingExistsGuard() {
  const { id: parkingId } = useParams<{ id: string }>();
  const { parking, loading } = useDashboardParkingData(parkingId ?? '');
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !parking) {
      const testId = TestId.root('parkingExistsGuardError');
      toast.danger(tr('owned_parking_manage:manage.errors.no_parking'), testId);
      navigate(ROUTE_PATHS[RouteName.MY_PARKINGS], { replace: true });
    }
  }, [loading, parking, navigate]);

  if (!parking) {
    return null;
  }

  return (
    <ParkingProvider parking={parking}>
      <Outlet />
    </ParkingProvider>
  );
}
